import { render, staticRenderFns } from "./FindPwForm.vue?vue&type=template&id=0f7dcf5a"
import script from "./FindPwForm.vue?vue&type=script&lang=js"
export * from "./FindPwForm.vue?vue&type=script&lang=js"
import style0 from "./FindPwForm.vue?vue&type=style&index=0&id=0f7dcf5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports